var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._visible
    ? _c(
        _vm.wrapperComponentType,
        {
          tag: "component",
          class: {
            "patient-panel-block": true,
            "description-mobile-visible": _vm.descriptionMobileVisible
          },
          attrs: { id: _vm.id },
          on: { click: _vm.click }
        },
        [
          _c(
            "div",
            {
              staticClass: "neu-card mx-auto px-4 px-xl-4",
              style: "backgroundColor: " + _vm._backgroundColor
            },
            [
              _vm._t("absolute-items"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "m-auto" },
                [
                  _c("base-icon", {
                    staticClass: "d-block mb-3",
                    attrs: {
                      src: _vm.img,
                      alt: "",
                      height: _vm.iconSize,
                      width: _vm.iconSize,
                      color: _vm._textAndIconColor
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    class: {
                      "neu-card-title": true,
                      "d-block": true,
                      "with-info": !!_vm.description
                    },
                    style: "color: " + _vm._textAndIconColor,
                    domProps: { innerHTML: _vm._s(_vm.title) }
                  }),
                  _vm._v(" "),
                  _vm._t("default"),
                  _vm._v(" "),
                  _vm.enabled
                    ? _c(
                        "span",
                        [
                          _vm.description
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "d-none d-xl-block neu-card-description"
                                },
                                [_vm._v(_vm._s(_vm.description))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.description && _vm.toggleableMobileDescription
                            ? _c(
                                "p",
                                {
                                  staticClass: "d-xl-none info-btn",
                                  on: {
                                    click: function(event) {
                                      event.stopPropagation()
                                      _vm.descriptionMobileVisible = !_vm.descriptionMobileVisible
                                    }
                                  }
                                },
                                [
                                  _c("base-icon", {
                                    attrs: {
                                      src:
                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/ICN_OUT_INFORMACION.svg",
                                      color: _vm._textAndIconColor
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.descriptionMobileVisible
                            ? _c(
                                "span",
                                {
                                  staticClass: "d-block mt-2",
                                  style: "color: " + _vm.GRAY_COLOUR
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.description)
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.actionable && !_vm.hideArrowMobileButton
                                    ? _c(
                                        "base-button",
                                        {
                                          staticClass: "mt-3",
                                          on: { click: _vm.click }
                                        },
                                        [
                                          _c("arrow-icon", {
                                            attrs: { color: "white" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.soonLabel
                            ? _c(
                                "b-badge",
                                {
                                  staticClass: "mt-3 soon-label",
                                  class: { blink: _vm.blinkSoonLabelActive },
                                  attrs: { variant: "primary" }
                                },
                                [_vm._v(_vm._s(_vm.$t("soon-label")))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "span",
                        [
                          _c(
                            "b-badge",
                            { staticClass: "mt-3", attrs: { variant: "info" } },
                            [_vm._v(_vm._s(_vm.notEnabledText))]
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.enabled ? _vm._t("footer") : _vm._e()
                ],
                2
              )
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e776b27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e776b27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PatientPanelServiceBlock.vue
// module id = 2496
// module chunks = 25 38 61 62 64 65 69 71 72 77 80 81 82 83